// Label and Canvas Marker colour for each brand_lifecycle_status, shown on the
// brand cards and in the brand details header.
export const LIFECYCLE_STATUS_BADGES = Object.freeze({
  DRAFT: { color: 'grey', label: 'Upload Pending' },
  EXTRACTION_IN_PROGRESS: { color: 'blue', label: 'Extraction Pending' },
  IN_REVIEW: { color: 'yellow', label: 'Review Pending' },
  REVIEW_COMPLETED: { color: 'yellow', label: 'Awaiting Publish' },
  AWAITING_PUBLISH: { color: 'blue', label: 'Publish In Progress' },
  ACTIVE: { color: 'green', label: 'Active' },
})
